module.exports = __webpack_public_path__ + "static/media/businessman-avatar-profile-picture-2.32c4b942.jpg";